var _style, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFooterGooglePlayBtn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "footer-google-play-btn_svg__Layer_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 56.7 17"
  },
  viewBox: "0 0 56.7 17"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".footer-google-play-btn_svg__st1{fill:#fff}.footer-google-play-btn_svg__st7{opacity:.12;fill:#010101;enable-background:new}")), /*#__PURE__*/React.createElement("g", {
  id: "footer-google-play-btn_svg__XMLID_1_"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "footer-google-play-btn_svg__XMLID_44_"
}, /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_82_",
  d: "M54.6 16.9H2.1C.9 16.9 0 16 0 14.8V2.2C0 1 .9.1 2.1.1h52.5c1.2 0 2.1.9 2.1 2.1v12.6c0 1.2-1 2.1-2.1 2.1z"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M54.6.4c1 0 1.8.8 1.8 1.8v12.6c0 1-.8 1.8-1.8 1.8H2.1c-1 0-1.8-.8-1.8-1.8V2.2c0-1 .8-1.8 1.8-1.8h52.5m0-.3H2.1C.9.1 0 1 0 2.2v12.6c0 1.2.9 2.1 2.1 2.1h52.5c1.2 0 2.1-.9 2.1-2.1V2.2c0-1.2-1-2.1-2.1-2.1z",
  style: {
    fill: "#a7a6a6"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.9 4.4c0 .4-.1.6-.3.8-.2.2-.5.4-.9.4s-.7-.1-.9-.4c-.3-.3-.4-.6-.4-.9 0-.4.1-.7.4-.9.2-.3.5-.4.9-.4.2 0 .4 0 .5.1.2.1.3.2.4.3l-.2.2c-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .3.1.5.3.7.2.2.4.3.7.3.3 0 .5-.1.7-.3.1-.1.2-.3.2-.5h-.9v-.3h1.2v.2zM21.8 3.4h-1.1v.8h1v.3h-1v.8h1.1v.3h-1.5V3h1.5v.4zM23.2 5.6h-.3V3.4h-.7V3h1.7v.3h-.7v2.3zM25.2 5.6V3h.3v2.5h-.3zM26.9 5.6h-.3V3.4h-.7V3h1.7v.3h-.7v2.3zM30.9 5.2c-.2.3-.6.4-.9.4-.4 0-.7-.1-.9-.4-.2-.3-.4-.6-.4-.9s.1-.7.4-.9c.2-.3.5-.4.9-.4s.7.1.9.4c.2.3.4.6.4.9 0 .4-.1.7-.4.9zM29.3 5c.2.2.4.3.7.3.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .3.1.5.3.7zM31.7 5.6V3h.4l1.2 2V3h.3v2.5h-.3L32 3.4v2.1h-.3zM28.6 9.2c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8zm0 2.9c-.5 0-1-.4-1-1.1 0-.6.5-1.1 1-1.1s1 .4 1 1.1c0 .7-.4 1.1-1 1.1zm-3.9-2.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8zm0 2.9c-.5 0-1-.4-1-1.1 0-.6.5-1.1 1-1.1s1 .4 1 1.1c0 .7-.5 1.1-1 1.1zM20 9.8v.8h1.8c-.1.4-.2.7-.4 1-.3.3-.7.6-1.4.6-1.1 0-2-.9-2-2s.9-2 2-2c.6 0 1 .2 1.4.5L22 8c-.5-.4-1.1-.8-1.9-.8-1.5 0-2.8 1.2-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8.8 0 1.4-.3 1.9-.8s.7-1.2.7-1.8v-.5H20zm19.1.6c-.1-.4-.6-1.1-1.5-1.1s-1.7.7-1.7 1.8c0 1 .8 1.8 1.8 1.8.8 0 1.3-.5 1.5-.8l-.6-.4c-.2.3-.5.5-.9.5s-.7-.2-.9-.5l2.4-1-.1-.3zm-2.5.6c0-.7.5-1 .9-1 .3 0 .6.2.7.4l-1.6.6zm-1.9 1.7h.8V7.5h-.8v5.2zm-1.3-3.1c-.2-.2-.5-.4-1-.4-.9 0-1.7.8-1.7 1.8s.8 1.8 1.7 1.8c.4 0 .8-.2.9-.4v.3c0 .7-.4 1-1 1-.5 0-.8-.3-.9-.6l-.7.3c.2.5.7 1.1 1.6 1.1.9 0 1.7-.5 1.7-1.9V9.3h-.7v.3zm-.9 2.5c-.5 0-1-.5-1-1.1 0-.6.5-1.1 1-1.1s1 .5 1 1.1c0 .7-.5 1.1-1 1.1zm10.3-4.6h-1.9v5.2h.8v-2h1.1c.9 0 1.7-.6 1.7-1.6s-.9-1.6-1.7-1.6zm0 2.5h-1.1V8.2h1.1c.6 0 .9.5.9.9s-.3.9-.9.9zm4.8-.8c-.6 0-1.2.2-1.4.8l.7.3c.1-.3.4-.4.7-.4.4 0 .8.2.8.7v.1c-.1-.1-.4-.2-.8-.2-.7 0-1.5.4-1.5 1.2 0 .7.6 1.2 1.3 1.2.5 0 .8-.2 1-.5v.4h.8v-2c0-1.1-.7-1.6-1.6-1.6zm-.1 2.9c-.3 0-.6-.1-.6-.4 0-.4.4-.6.8-.6.3 0 .5.1.7.2 0 .5-.4.8-.9.8zM52 9.3l-.9 2.3-.9-2.3h-.8l1.4 3.2-.8 1.8h.8l2.2-5h-1zm-7.1 3.4h.8V7.5h-.8v5.2z",
  className: "footer-google-play-btn_svg__st1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "footer-google-play-btn_svg__XMLID_56_",
  x1: 9.155,
  x2: 2.107,
  y1: 15.225,
  y2: 8.178,
  gradientTransform: "matrix(1 0 0 -1 0 18.988)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#4998d3"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  style: {
    stopColor: "#4a99d3"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  style: {
    stopColor: "#42baeb"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  style: {
    stopColor: "#41c7f2"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  style: {
    stopColor: "#56c9e9"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#5bcae8"
  }
})), /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_16_",
  d: "M4.4 3.3c-.1.1-.2.3-.2.6v9.3c0 .3.1.5.2.6l5.2-5.2v-.2L4.4 3.3z",
  style: {
    fill: "url(#footer-google-play-btn_svg__XMLID_56_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "footer-google-play-btn_svg__XMLID_65_",
  x1: 14.209,
  x2: 4.047,
  y1: 10.483,
  y2: 10.483,
  gradientTransform: "matrix(1 0 0 -1 0 18.988)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#fee000"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  style: {
    stopColor: "#febd11"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  style: {
    stopColor: "#faa51a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#f99b1c"
  }
})), /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_15_",
  d: "M11.4 10.3 9.6 8.6v-.2l1.7-1.7 2.1 1.2c.6.3.6.9 0 1.2l-2 1.2z",
  style: {
    fill: "url(#footer-google-play-btn_svg__XMLID_65_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "footer-google-play-btn_svg__XMLID_66_",
  x1: 10.426,
  x2: 0.869,
  y1: 9.52,
  y2: -0.038,
  gradientTransform: "matrix(1 0 0 -1 0 18.988)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#ef4149"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#c31e63"
  }
})), /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_13_",
  d: "M11.4 10.3 9.6 8.5l-5.2 5.2c.2.2.5.2.9 0l6.1-3.4",
  style: {
    fill: "url(#footer-google-play-btn_svg__XMLID_66_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "footer-google-play-btn_svg__XMLID_67_",
  x1: 3.064,
  x2: 7.332,
  y1: 18.809,
  y2: 14.541,
  gradientTransform: "matrix(1 0 0 -1 0 18.988)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#32a072"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.069,
  style: {
    stopColor: "#2ca772"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  style: {
    stopColor: "#4bba71"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  style: {
    stopColor: "#5ebd6b"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#66be69"
  }
})), /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_12_",
  d: "M11.4 6.7 5.3 3.2c-.4-.2-.7-.1-.9.1l5.2 5.2 1.8-1.8z",
  style: {
    fill: "url(#footer-google-play-btn_svg__XMLID_67_)"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_11_",
  d: "m11.4 10.2-6.1 3.5c-.3.2-.6.2-.8 0 .2.2.5.2.8 0l6.1-3.5z",
  style: {
    opacity: 0.2,
    fill: "#010101",
    enableBackground: "new"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_10_",
  d: "M4.4 13.7c-.1-.1-.2-.3-.2-.6v.1c0 .2.1.4.2.5z",
  className: "footer-google-play-btn_svg__st7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_9_",
  d: "m13.4 9-2.1 1.2L13.4 9c.3-.1.4-.3.4-.5.1.2-.1.4-.4.5z",
  className: "footer-google-play-btn_svg__st7"
})), /*#__PURE__*/React.createElement("path", {
  id: "footer-google-play-btn_svg__XMLID_8_",
  d: "M5.3 3.3 13.4 8c.3.2.4.3.4.5 0-.2-.1-.4-.4-.6L5.3 3.3c-.6-.4-1.1-.1-1.1.6V4c0-.8.5-1 1.1-.7z",
  style: {
    opacity: 0.25,
    fill: "#fff",
    enableBackground: "new"
  }
})));
export { SvgFooterGooglePlayBtn as ReactComponent };
export default __webpack_public_path__ + "bd861351df9279e98e447966832bb59c.svg";